import { render, staticRenderFns } from "./page-delete-dialog.vue?vue&type=template&id=72a1bfac&"
import script from "./page-delete-dialog.vue?vue&type=script&lang=js&"
export * from "./page-delete-dialog.vue?vue&type=script&lang=js&"
import style0 from "./page-delete-dialog.vue?vue&type=style&index=0&id=72a1bfac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports